import { Modal } from "antd";

export default function DeleteModal({ open, onclose, entity, onDelete }) {
  return (
    <Modal
      open={open}
      onCancel={onclose}
      onOk={onDelete}
      okButtonProps={{ size: "large", style: { background: "#f00" } }}
      okText={"Yes"}
      cancelButtonProps={{ size: "large" }}
      width={450}
      styles={{
        body: { height: "80px", fontSize: "18px" },
      }}
      centered
    >
      <p>
        {"Are you sure you want to "}
        <span style={{ color: "#f00" }}>delete</span>
        {` this ${entity}?`}
      </p>
    </Modal>
  );
}
